import { getOtp } from '@/api/api.auth';
import { cn } from '@/lib/utils';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export function ResendOtpLink({ cooldown, email, password }: { cooldown: number; email: string; password: string }) {
  const [countdown, setCountdown] = useState(cooldown);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleResendOtp = async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    if (countdown > 0) {
      return;
    }
    try {
      const response = await getOtp(email, password);
      if (response.status === 200 || response.data.succeeded > 0) {
        setCountdown(cooldown);
        toast.success('New passcode sent successfully.', {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error((error as Error).message || 'Failed to resend passcode.', {
        autoClose: 3000,
      });
    }
  };

  return (
    <Link className={cn('text-neutral-400 mt-1 text-sm', countdown > 0 ? 'cursor-default' : '')} onClick={handleResendOtp} to={'/'}>
      {countdown > 0 ? `Didn't receive a passcode? Resend in ${countdown}s` : `Didn't receive a passcode? Click here to resend`}
    </Link>
  );
}
